import React, { useState } from "react";
import {
    Grid,
    InputLabel,
    FormHelperText,
    TextField,
    InputAdornment,
    IconButton,
} from "@mui/material";
import { Formik } from "formik";
import { MainCard } from "../../../components/surface/MainCard";
import { SectionBox } from "../../../components/surface/SectionBox";
import { WarrantyPreAuthDTO } from "../../../models/WarrantyPreAuth";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { apiStore } from "../../../api/ApiFactory";
import WarrantyPreAuthEditing from "./WarrantyPreAuthEditing";

const PreAuthCreate = () => {
    const [showPreAuthEditing, setShowPreAuthEditing] = useState<boolean>(false);
    const [hinNum, setHinNum] = useState('');
    const [warrantyPreAuth, setWarrantyPreAuth] = useState<WarrantyPreAuthDTO | null>(null);
    const [errorMessage, setErrorMessage] = useState('');

    const handleHinSearch = () => {
        if (!hinNum) {
            setErrorMessage('HIN # is required.');
        }
        else if (hinNum.length >= 6) {
            const queryParams: { hin?: string } = hinNum ? { hin: hinNum } : {};
            apiStore.warrantypreauthApi
                .getDetailsByHin(queryParams)
                .then((res: any) => {

                    if (!res || Object.keys(res).length === 0) {
                        setErrorMessage('No record found for the provided HIN #.');
                        setShowPreAuthEditing(false);
                    } else {
                        setWarrantyPreAuth(res);
                        setShowPreAuthEditing(!!res);
                        setErrorMessage('');
                    }
                })
                .catch((error: any) => {
                    console.error(error);

                    if(error.errors && error.errors[""] !== undefined) {
                        setErrorMessage(error.errors[""][0]);
                    }
                    else {
                        setErrorMessage('An error occurred while fetching the data.'); 
                    }

                    setShowPreAuthEditing(false);
                });
        }
        else {
            setErrorMessage('Please enter at least 6 characters to perform a search.');
            setShowPreAuthEditing(false);
        }
    };

    return (
        <>
            <Formik
                initialValues={{ record: { preAuthorization: '', hinNum: '' } }}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(false);
                }}
                enableReinitialize
            >
                {({ errors, handleSubmit, getFieldProps, values }) => (
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={4}>
                            <Grid item xs={12}>
                                {!warrantyPreAuth && (
                                    <MainCard title="HIN Lookup" divider>                                         
                                                <SectionBox>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12}>
                                                            <InputLabel htmlFor="record.hinNum" sx={{ fontWeight: 'bold' }}>HIN #</InputLabel>
                                                            <TextField
                                                                disabled={false}
                                                                size="small"
                                                                fullWidth
                                                                placeholder="#HIN"
                                                                value={hinNum}
                                                                onChange={(e) => setHinNum(e.target.value)}
                                                                aria-label="Dealer Comment"
                                                                sx={{ width: '400px' }}
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <IconButton onClick={handleHinSearch} edge="end">
                                                                                <ArrowForwardIcon />
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    ),
                                                                }}
                                                            />
                                                            {errorMessage && <FormHelperText error>{errorMessage}</FormHelperText>}
                                                        </Grid>
                                                    </Grid>
                                                </SectionBox> 
                                    </MainCard>
                                )}

                            </Grid>
                        </Grid>
                    </form>

                )}
            </Formik>
            {showPreAuthEditing && warrantyPreAuth && (
                <WarrantyPreAuthEditing preAuth={warrantyPreAuth} />
            )}
        </>
    );
};

export default PreAuthCreate;
